<template>
    <div>
        <rkm-row>
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.antecedente.descricao"
                    label="Informações relacionadas aos antecedentes do paciente"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxPreNatalPartoNascimento
                    v-if="item.isAtendimentoPuericultura && !item.puericultura.isPrimeiroAtendimento"
                    :item="item"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxInformacaoObstetrica
                    v-if="item.sexoId === enums.sexo.FEMININO"
                    :item="item"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxProblemaCondicao
                    :item="item"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxCirurgiaInternacao
                    :item="item"
                />
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Components.
import BoxCirurgiaInternacao from './components/cirurgia-internacao/Index'
import BoxInformacaoObstetrica from './components/informacao-obstetrica/Index'
import BoxPreNatalPartoNascimento from '@/components/ambulatorio/atendimento/components/historico/components/pre-natal-parto-nascimento/Index'
import BoxProblemaCondicao from './components/problema-condicao/Index'
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

// Enums.
import sexo from '@/enums/cadastro/cidadao/sexo'

export default {
    components: {
        BoxCirurgiaInternacao,
        BoxInformacaoObstetrica,
        BoxPreNatalPartoNascimento,
        BoxProblemaCondicao,
        Item
    },
    data: () => ({
        enums: {sexo},
    }),
    props: {
        item: {type: Object, required: true},
    },
}
</script>